import * as emailTemplateService from './emailTemplate.service';

export const EmailMessage = {
  ...emailTemplateService,
};
